import { useQuery } from '@tanstack/react-query';
import { useApiClient } from './useApiClient';

interface GithubSshConfig {
    tenantId: string;
    name: string;
    description?: string;
    repositoryUrl: string;
    accessMethod: 'ssh' | 'pat';
    connectionType?: 'repository' | 'organization' | 'user';
    keyType?: 'rsa' | 'ed25519';
    isActive: boolean;
    secretArn?: string;
    publicKey?: string;
    createdAt: string;
    updatedAt: string;
}

interface GithubSshConfigResponse {
    success: boolean;
    connections: GithubSshConfig[];
}

const useGithubSshConfigs = () => {
    const apiClient = useApiClient();

    return useQuery({
        queryKey: ['githubSshConfigs'],
        queryFn: async (): Promise<GithubSshConfig[]> => {
            const response = await apiClient.get('/configurations/connections/github');

            if (!response.ok) {
                throw new Error(`Failed to fetch GitHub SSH connections: ${response.statusText}`);
            }

            const data: GithubSshConfigResponse = await response.json();
            return data.connections || [];
        }
    });
};

export default useGithubSshConfigs;